import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Image from '../Reusable/Image';
import { PngImages, SvgImages } from '../../Utils/LocalImages';
import SubmitButton from '../Reusable/Buttons';
import RoutesPath from '../../Utils/RoutesPath';
import SessionManager from '../../Utils/Session';
import { handleApiErrors } from '../../Utils/Utils';
import StudentDashboardServices from '../../Services/StudentDashboardApiService';
import { AuthContext } from '../../Context/authContext';

const Navbar = () => {
  const {user}=useContext(AuthContext)
  const [isOpen, setIsOpen] = useState(false);
  const [showLoginDropDown, setShowLoginDropDown] = useState(false);
  const sessionToken = SessionManager.shared.getSessionToken();

  const navigate = useNavigate()
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    // Add event listener to listen for clicks on the document
    document.addEventListener('click', handleClickOutside);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // Function to handle click outside of the modal
  const handleClickOutside = (event) => {
    const dropdownMenu = document.getElementById('dropdownMenuLink');
    if (dropdownMenu && !dropdownMenu.contains(event.target)) {
      setShowLoginDropDown(false);
    }
  };

  const tabs = [
    { id: 'home', label: 'Home', to: RoutesPath.home },
    { id: 'about', label: 'About Us', to: RoutesPath.aboutUs },
    { id: 'services', label: 'Our Services', to: RoutesPath.services },
    { id: 'bharat-sat', label: 'Bharat SAT', to: RoutesPath.bharatSAT },
    { id: 'contact', label: 'Contact Us', to: RoutesPath.contactUs },
    { id: 'bharatSatScholarship', label: 'Bharat-SAT Scholarship', to: RoutesPath.bharatSatScholarship },
    { id: 'join', label: 'Join & Earn', to: RoutesPath.joinAsCoordinator }
  ];





  return (
    <div className='navigationBar px-5 '>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid gap-3 p-0">
          <div className='icon-nav'>
            <Link to={RoutesPath.home} className="navbar-brand">

              <Image src={SvgImages.logo} />
            </Link>
          </div>

          <div className={`navbar-collapse navigation ms-auto collapse ${isOpen ? 'show order-2' : ''}`} id="navbarNavDropdown">
            <ul className="navbar-nav navbarlist gap-3 align-items-center">
              {tabs.map(tab => (
                <li className="nav-item" key={tab.id}>
                  <Link
                    className={`nav-link Sub-Heading1  py-0 px-1 ${location.pathname === tab.to ? 'active' : ''}`} style={{ color: 'black', color: location.pathname === tab.to ? '#004080' : 'Black', fontWeight: location.pathname === tab.to ? '600' : 'normal' }}
                    to={tab.to}
                    onClick={closeMenu}>
                    {tab.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className='Button-navbar respomobspace ms-auto position-relative' >
            {sessionToken && user.user_id ?
              <SubmitButton  title={"Go to Dashboard"} reducewidth="reducewidthrespo" onClick={() => navigate(RoutesPath.dashboardstudent)} navbarloginbtn="navbarloginbtn" hoverTitle="Go to Dashboard" />
              : <SubmitButton id="dropdownMenuLink" title={"Login"} onClick={() => setShowLoginDropDown(!showLoginDropDown)} />
            }
             <button className="navbar-toggler mobileNavMenuBtn p-0" data-bs-toggle="collapse" aria-controls="navbarNavDropdown" onClick={toggleMenu} >
            <Image src={SvgImages.navBarMenu} />
          </button>

            <div className={`dropdown-menu profiles_dropdown selectSection ${showLoginDropDown ? "show" : ""}`} aria-labelledby="dropdownMenuLink" data-popper-placement="bottom-end">
              <div className='d-flex gap-3 align-items-center'>
                <Image src={PngImages.loginPopupIllustration} style={{ height: 70, aspectRation: 1 }} />
                <div className='d-flex flex-column gap-2' style={{ width: "max-content" }}>
                  <h2 className='Sub-Heading black mb-0 fw-600'>Have you registered...?</h2>
                  <div className='d-flex gap-2'>
                    <Link to={RoutesPath.login}>
                      <button className='login-popup-button medium-text' style={{ backgroundColor: "#0050CF", cursor: 'pointer' }}>Yes</button>
                    </Link>
                    <Link to={RoutesPath.studentRegistration}>
                      <button className='login-popup-button medium-text' style={{ backgroundColor: "#F6821F" }}>No</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

         
        </div>
      </nav>
    </div>
  );
};

export default Navbar;

